$( document ).ready(function() {
    var current = 0;
    $('.b-gallery-list__item').click(function () {
        $('.b-gallery-list__item').removeClass('b-gallery-list__item--active');
        $(this).addClass('b-gallery-list__item--active');
        current = $(this).data('current');
        $('.b-gallery-big__image').removeClass('b-gallery-big__image--active');
        var item = $(".b-gallery-big").find("[data-item='" + current + "']");
        item.addClass('b-gallery-big__image--active');
    })
});
